<template>
  <el-dialog v-loading="loading"
             title="SKU设置"
             :visible.sync="dialogVisible"
             custom-class="importDialog"
             append-to-body
             @close="hide"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="form"
             :rules="rules"
             ref="refDialog"
             label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="profession"
                        label="行业">
            <el-select clearable
                       v-model="form.profession"
                       placeholder="请选择"
                       disabled
                       style="width: 90%">

            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="business"
                        label="商家">
            <el-select clearable
                       disabled
                       v-model="form.business"
                       placeholder="请选择"
                       style="width: 90%">

            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="store"
                        label="店铺">
            <el-select clearable
                       disabled
                       v-model="form.store"
                       placeholder="请选择"
                       style="width: 90%">

            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="td"
                        label="到仓时间">
            <!-- <el-date-picker v-model="form.td" type="datetime" placeholder="选择日期时间"></el-date-picker> -->
            <el-input-number v-model="form.td"
                             controls-position="right"
                             :precision="0"
                             :min="1"></el-input-number>
            <!-- <el-input min="1"
                      type="number"></el-input> -->
            <span>（从下单到货物到达店铺仓库需要的天数）</span>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="to"
                        label="上架时间">

            <el-input-number v-model="form.to"
                             controls-position="right"
                             :precision="0"
                             :min="1"></el-input-number>
            <span>（从货物到达店铺仓到货物上架出售需要的天数）</span>
          </el-form-item>
        </el-col>
        <el-col>
          <el-row class="row">
            <el-col :span="3">
              <!-- prop="tp_type" -->
              <el-form-item label="补货方式"
                            style="margin-bottom: 0px;"></el-form-item>
            </el-col>
            <el-col :span="18">（预订下单补货时间）[从下面两种补货方式中，选择一种]</el-col>
          </el-row>
          <el-row>
            <el-row class="row">
              <el-col :span="5">
                <el-radio v-model="form.tp_type"
                          :label="1">按周期补货</el-radio>
              </el-col>
              <div class
                   v-if="form.tp_type ===1">
                <el-col :span="8">
                  <el-form-item prop="tp_every"
                                label-width="20px">
                    <!-- <el-input v-model="form.tp_every"></el-input> -->
                    <el-select clearable
                               v-model="form.tp_every"
                               placeholder="请选择"
                               @change="tpEveryChange"
                               style="width: 90%">
                      <!-- <el-option v-for="item in tradestatus" :key="item.id" :label="item.name" :value="item.code">{{ item.name }}</el-option> -->
                      <el-option v-for="item in Desc.selectList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                        <el-row>
                          <el-col :span="22">{{item.label}}</el-col>
                          <el-col :span="2">
                            <el-tooltip class="item"
                                        effect="dark"
                                        :content="item | tooltipContent"
                                        placement="right">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </el-col>
                        </el-row>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">的第</el-col>
                <el-col :span="5">
                  <el-form-item prop="tp_day"
                                label-width="0px">
                    <el-input-number controls-position="right"
                                     :precision="0"
                                     @change="tpDayChange"
                                     v-model="form.tp_day"
                                     :min="1"></el-input-number>
                    <!-- <el-input min="1"
                              type="number"
                              @change="tpDayChange"
                              :max="rangeMax"
                              v-model="form.tp_day"></el-input> -->
                  </el-form-item>

                  <!-- <el-input min="1"
                              type="number"></el-input> -->
                  <!-- </el-form-item> -->
                </el-col>
                <el-col :span="1">天</el-col>
              </div>
            </el-row>
            <el-row class="row">
              <el-col :span="7">
                <el-radio v-model="form.tp_type"
                          :label="2">按指定日期补货</el-radio>
              </el-col>
              <div class
                   v-if="form.tp_type ===2">
                <el-col :span="13">
                  <!-- <el-row> -->
                  <div>
                    <el-row v-for="(item, index) in form.tp_date"
                            :key="index">
                      <!-- <el-input v-model="item.value"></el-input> -->
                      <el-col :span="20">
                        <el-form-item prop="tp_date"
                                      label-width="0px">
                          <el-date-picker v-model="item.value"
                                          type="date"
                                          value-format="yyyy-MM-dd"
                                          placeholder="选择日期时间"></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-button @click="handleDel(index)"
                                   type="text">删除</el-button>
                      </el-col>
                    </el-row>
                  </div>

                  <!-- </el-row> -->
                </el-col>
                <el-col style="margin-top:8px;"
                        :offset="7"
                        :span="6">
                  <el-button @click="handleAdd">添加</el-button>
                </el-col>
              </div>
            </el-row>
          </el-row>
        </el-col>
        <el-col>
          <el-row class="row">
            <el-col>调整时间:</el-col>
          </el-row>
          <el-row>
            <el-form-item prop="tv1"
                          label-width="190px"
                          label="下次补货延迟天数预估">
              <el-input-number v-model="form.tv1"
                               controls-position="right"
                               :precision="0"
                               :min="1"></el-input-number>
              <!-- <el-input min="0"
                        type="number"
                        v-model="form.tv1"></el-input> -->
            </el-form-item>
            <el-form-item prop="tv2"
                          label-width="190px"
                          label="再下次补货延迟天数预估">
              <el-input-number v-model="form.tv2"
                               controls-position="right"
                               :precision="0"
                               :min="1"></el-input-number>
              <!-- <el-input min="0"
                        type="number"
                        v-model="form.tv2"></el-input> -->
            </el-form-item>
          </el-row>
          <el-row style="margin-bottom: 15px">（由于特殊原因导致补货到仓和上架时间会发生延迟的天数预估）</el-row>
        </el-col>
        <el-col>
          <el-form-item prop="ri"
                        label-width="130px"
                        label="调整系数">
            <el-input v-model="form.ri"
                      type="number"></el-input>
            <span>（销售增长率预估）</span>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="start_time"
                        label-width="135px"
                        label="补货逻辑开始时间">
            <el-date-picker v-model="form.start_time"
                            type="date"
                            placeholder="请选择开始日期"
                            value-format="yyyy-MM-dd"
                            style="width: 80%"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
import { rules } from './data.js'
let _rule = JSON.parse(JSON.stringify(rules))
import * as Desc from './desc'
import { dealReturn } from '@/common/js'

export default {
  // mixins: [getplatlists, getptnlists, getshoplists],
  props: { queryInfo: Object, skus: { type: Array, required: true } },

  data() {
    return {
      dialogVisible: false,
      query: this.queryInfo,
      form: {
        profession: '',
        business: '',
        store: '',
        tp_every: '',
        tp_day: undefined,
        tp_date: [{ value: '' }],
        skus: [],
        start_time: Desc.yestDate()
      },
      loading: false,
      rules: _rule,
      loading: false,
      Desc,
      rangeMax: '',
    }
  },
  methods: {
    show(query) {
      this.query = query
      this.getReplenishSetByStore()
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
      this.form = {
        profession: '',
        business: '',
        store: '',
        tp_every: '',
        tp_day: undefined,
        tp_date: [{ value: '' }],
        skus: [],
        start_time: ''
      }
      this.$refs.refDialog.resetFields()
      console.log('hide')
    },
    handleAdd() {
      this.form.tp_date.push({ value: '' })
    },
    handleDel(index) {
      this.form.tp_date.splice(index, 1)
    },
    tpDayChange(val) {
      console.log('tpDayChage', val)
      if (this.form.tp_day > this.rangeMax) {
        this.form.tp_day = this.rangeMax
        this.$message.error('‘第几天’不能超过当前选项范围')
      }
    },
    tpEveryChange(val) {
      // console.log('change', val, this.form.tp_day)
      this.form.tp_day = undefined

      // if (this.form.tp_day > this.rangeMax) {
      //   this.form.tp_day = this.rangeMax
      //   this.$message.error('‘第几天’不能超过当前选项范围')
      // }
    },

    submit() {
      let isValid
      this.$refs.refDialog.validate((valid) => {
        isValid = valid
      })
      if (!isValid) return
      this.form.sku = this.sku
      // 获取 this.form.tp_date 的数据
      let list = []
      for (let item of this.form.tp_date) {
        if (item.value) {
          list.push(item.value)
        }
      }
      if (this.form.tp_type === 1) {
        if (!this.form.tp_every || !this.form.tp_day) {
          this.$message({
            type: 'error',
            message: '请填写完整“按周期补货”信息',
          })
          return
        }
        // 检查必填项
      } else if (this.form.tp_type === 2) {
        // 检查必填项
        if (list.length === 0) {
          this.$message({
            type: 'error',
            message: '请填写完整“按指定日期补货”信息',
          })
          return
        }
      } else {
        this.$message({
          type: 'error',
          message: '必须选择一种补货方式',
        })
        return
      }
      // 检查“第几天”的值是否在范围内

      this.$confirm('此操作将覆盖之前的配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // this.$message({
          //   type: "success",
          //   message: "删除成功!",
          // });
          // 发请求
          let form = JSON.parse(JSON.stringify(this.form))
          form.tp_date = list
          form.skus = this.query.skus
          this.submitApi(form)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    async submitApi(form) {
      this.loading = true
      let query = {
        url: 'supplySetSku',
        title: '设置',
        method: 'post'
      }
      let { data, err } = await this.axiosApi(query, form)
      this.loading = false
      console.log(data.data)
      if (data && data.data.meta && data.data.meta.status === 200) {
        //
        this.getrestSkuList()
        this.$message.success(data.data.data)
        this.hide()
      } else {
        // this.$message.error(err.response.data.message);
      }
      dealReturn(data, err)
    },
    async getReplenishSetByStore() {
      let url = (this.query.edit && this.query.remark) ? 'getReplenishSetByStoreSku' : 'getReplenishSetByStore'
      let query = {
        url: url,
        title: '单补货设置读取',
        method: 'post'
      }
      let { data, err } = await this.axiosApi(
        query,
        this.query
      )
      // console.log(data)
      if (data && data.status === 200) {
        console.log(data)
        // this.form = data.data.data
        this.setFrom(JSON.parse(JSON.stringify(data.data.data)))
      }

      dealReturn(data, err)
    },
    getrestSkuList() {
      this.$emit('getrestSkuList')
    },
    setFrom(data) {
      if (!data.id) {
        this.form.profession = this.query.profession
        this.form.business = this.query.business
        this.form.store = this.query.store
        return
      }
      if (data.id) {
        this.form = data
        let new_date = []
        if (data.tp_date) {
          for (const tpdate of data.tp_date) {
            new_date.push({ value: tpdate })
          }
        }
        this.form.tp_date = new_date
        this.form.start_time = this.form.start_time ? this.form.start_time : Desc.yestDate()
        return
      }
    },
  },
  watch: {
    'form.tp_type': function (val) {
      // 动态设置 rules 会触发 trigger="blur" 的校验， 不搞
      // 参见：https://github.com/ElemeFE/element/issues/2846
      if (this.form.tp_type === 1) {
        if (!this.form.tp_every || !this.form.tp_day) {
          this.form.tp_date = [{ value: '' }]
        }
        // 检查必填项
      } else if (this.form.tp_type === 2) {
        // 检查必填项
        this.form.tp_every = ''
        this.form.tp_day = ''
      } else {
      }
    },
    'form.tp_every': function (val) {
      this.Desc.selectList.forEach((item) => {
        if (item.value === val) {
          this.rangeMax = item.range[1]
          console.log('this.rangeMax', this.rangeMax)
        }
      })
    },
  },
  filters: {
    tooltipContent: function (item) {
      return `‘第几天’的范围：${item.range[0]}--${item.range[1]} `
    },
  },
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialog {
    width: 700px;
  }
  .el-input {
    max-width: 200px;
  }
  label {
    font-size: 15px;
    // font-weight: 600;
  }
  .row {
    margin-top: 15px;
    .el-col {
      // height: 32px;
      line-height: 32px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/supply/skusetdialog.vue